import axios from "axios";
import ApiConfig from "./config";
import { Keycloaktokens } from "../storage/store";

/**
 * Create an Axios Client with defaults
 */
const axiosClient = axios.create({
  baseURL: ApiConfig.baseUrl,
  timeout: 30000,
});

// let initOptions = {
//     url: 'https://auth.hashh.io/auth/',
//     realm: 'HASHh',
//     clientId: 'hashh-dashboard',
//     onLoad: 'check-sso',
//     KeycloakResponseType: 'code',
//     scopes: ['openid', 'profile'],
// }

// const keycloak = new Keycloak(initOptions);

// keycloak.init({ onLoad: initOptions.onLoad, KeycloakResponseType: 'code', checkLoginIframe: false }).then((auth) => {
//     if (!auth) {
//         //window.location.reload();
//         console.info("Authenticated Failed");
//     } else {
//         console.info("Authenticated");
//         console.log(keycloak.token);
//         //navigate.push ('SelectEcoSystem');
//     }
// }, () => {
//     console.error("Authenticated Failed");
// });

// const keycloak = Keycloak.init({
//     onLoad: 'check-sso',
// });
// The access token's expiry in milliseconds, read from its payload; null when
// it can't be read.
const expiryOf = (token) => {
  try {
    const { exp } = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return typeof exp === "number" ? exp * 1000 : null;
  } catch (error) {
    return null;
  }
};

const SIGNED_OUT = "Your login has expired. Signing you in again…";
const SIGN_IN_AGAIN_AT = "signInAgainAt";

// The login ran out: sign in again. The login server signs the user straight
// back in while its own session lasts, or shows its login page. The API can't
// say so itself (an expired token gets a redirect to its login page, which the
// browser reports as a network error), so the token's expiry is checked here.
// It redirects at most once a minute, so a computer clock that is far off
// can't loop.
const signInAgain = () => {
  try {
    const last = Number(sessionStorage.getItem(SIGN_IN_AGAIN_AT));
    if (last && Date.now() - last < 60000) return false;
    sessionStorage.setItem(SIGN_IN_AGAIN_AT, String(Date.now()));
  } catch (error) {
    // Without session storage there's no loop guard; don't redirect.
    return false;
  }
  Keycloaktokens.removeToken();
  if (window.location.pathname !== "/Login") window.location.assign("/Login");
  return true;
};

/**
 * Request Wrapper with default success/error actions
 */
// keepStatus: reject with { status, data } instead of the body alone, for
// callers that act on the HTTP status (the Automation screens: 404 means the
// feature is off for the home, 409 asks to confirm a lock, gate or alarm).
const Api = async (
  config = { method: "GET", data: {}, url: "" },
  shouldAppendToken = true,
  { keepStatus = false } = {}
) => {
  // Success
  const onSuccess = (response) => {
    // console.log("response", JSON.stringify(response.data, null, 2));
    return Promise.resolve(response.data);
  };

  // Error
  const onError = (error) => {
    // console.log("Request Failed:", error);

    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      // console.log("Data:", error.response.data);
      if (keepStatus) return Promise.reject({ status: error.response.status, data: error.response.data });
      return Promise.reject(error.response.data);
    } else {
      // Something else happened while setting up the request
      // triggered the error
      // console.log("Error Message:", error.message);
      return Promise.reject(error.message);
    }
  };

  // Append headers
  let headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  // Append auth token
  if (shouldAppendToken) {
    try {
      const token = Keycloaktokens.getToken();
      const expiry = token ? expiryOf(token) : null;
      if (expiry && expiry <= Date.now() && signInAgain()) {
        return Promise.reject(SIGNED_OUT);
      }
      headers["Authorization"] = `Bearer ${token}`;
      // console.log(token);
    } catch (error) {
      // Token is not found
      // console.log("Error Message:", error.message);

      return Promise.reject(error.message);
    }
  }

  // Set headers
  axiosClient.defaults.headers = headers;

  // console.log("Request Headers!", axiosClient.defaults.headers);
  // console.log("Request Configurations!", config);

  return axiosClient(config).then(onSuccess).catch(onError);
};

export default Api;
